import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/app/apps/dashboard-app/app/(public)/forgot-password/form.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/i11n/client/index.ts");
